export default [
    {
        name: "contactModels",
        type: "fbx",
        path: "models/Social_Media_Icons_v02.fbx"
    },
    {
        name: "orbitModel",
        type: "fbx",
        path: "models/nurbsCircle.fbx"
    },
    // { 
    //     name: "cassini",
    //     type: "fbx",
    //     path: "models/Cassini.fbx"
    // },
    // {
    //     name: "foilNormalTexture",
    //     type: "texture",
    //     path: "textures/foil_n.png"
    // },
    // {
    //     name: "dog",
    //     type: "fbx",
    //     path: "models/dogRun.fbx"
    // },
    // {
    //     name: "dogColorTexture",
    //     type: "texture",
    //     path: "textures/Labrador.jpg"
    // },
    // {
    //     name: "environmentMapTexture",
    //     type: "cubeTexture",
    //     path: [
    //         "planetMaps/Env_MilkyWay/px.png",
    //         "planetMaps/Env_MilkyWay/nx.png",
    //         "planetMaps/Env_MilkyWay/py.png",
    //         "planetMaps/Env_MilkyWay/ny.png",
    //         "planetMaps/Env_MilkyWay/pz.png",
    //         "planetMaps/Env_MilkyWay/nz.png",
    //     ]
    // },
    // {
    //     name: "environmentMapTextureStars",
    //     type: "cubeTexture",
    //     path: [
    //         "planetMaps/Env_Stars/px_1k.jpg",
    //         "planetMaps/Env_Stars/nx_1k.jpg",
    //         "planetMaps/Env_Stars/py_1k.jpg",
    //         "planetMaps/Env_Stars/ny_1k.jpg",
    //         "planetMaps/Env_Stars/pz_1k.jpg",
    //         "planetMaps/Env_Stars/nz_1k.jpg",
    //     ]
    // },
    {
        name: "sunTexture",
        type: "texture",
        path: "planetMaps/sun_512.jpg"
    },
    {
        name: "starAlpha",
        type: "texture",
        path: "textures/starAlpha.png"
    }
]